
export class Color {
  id:string ;
  itemColor:string ;
  itemHexColor: string ;
}
